export default __webpack_public_path__ + "images/bdf8ed5e3785d05cf4dc2d83eabe2d91-yoga.jpg";